import { render } from "./BaseCard.vue?vue&type=template&id=590f8288&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=590f8288&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aurel\\Desktop\\new-website\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590f8288"]])

export default __exports__